import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CheckpointEditorFormModelNames, CheckpointType } from '@fi-shared/checklist/checklist-enum';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-checkpoint-type-editor',
    template: `
        <p class="checkpoint-edit-section-name">{{ 'checklist.checkpoint_type' | fiAppText }}</p>
        <mat-radio-group
            class="checkpoint-type-container"
            [(ngModel)]="ngModel"
            [name]="CheckpointEditorFormModelNames.Type"
            required
            (ngModelChange)="doPropagateChanges()"
        >
            <mat-radio-button [value]="CheckpointAnswerType.Status">
                <span class="checkpoint-type-name">{{ 'common.status' | fiAppText }}</span>
                <span class="checkpoint-type-description">{{
                    'checklist.checkpoint_type_status_description' | fiAppText
                }}</span>
            </mat-radio-button>
            <mat-radio-button [value]="CheckpointAnswerType.Measurement">
                <span class="checkpoint-type-name">{{ 'checklist.checkpoint_type_measurement' | fiAppText }}</span>
                <span class="checkpoint-type-description">{{
                    'checklist.checkpoint_type_measurement_description' | fiAppText
                }}</span>
            </mat-radio-button>
        </mat-radio-group>
    `,
    styleUrls: ['./type-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-type-editor' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiCheckpointTypeEditorComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiCheckpointTypeEditorComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiCheckpointTypeEditorComponent extends ControlValueAccessorValidatorBase<CheckpointType> {
    protected readonly CheckpointAnswerType = CheckpointType;
    protected readonly CheckpointEditorFormModelNames = CheckpointEditorFormModelNames;
}
